import React from "react";
import { Sparkles, Award, TrendingUp, HeartHandshake, ShieldCheck } from "lucide-react";
import Reveal from "../components/Reveal";

const VALUES = [
  { icon: Sparkles, t: "Élégance" }, { icon: Award, t: "Qualité" }, { icon: TrendingUp, t: "Tendance" },
  { icon: HeartHandshake, t: "Proximité" }, { icon: ShieldCheck, t: "Confiance" },
];
const STATS = [
  { n: "500+", l: "Clientes satisfaites" }, { n: "150+", l: "Articles disponibles" },
  { n: "40+", l: "Ventes privées organisées" }, { n: "32", l: "Communes livrées" },
];

export default function APropos() {
  return (
    <div data-testid="apropos-page">
      <div className="bg-noir text-center py-16 px-6 grain relative">
        <h1 className="font-display text-4xl md:text-6xl text-white relative">L'histoire d'Esther</h1>
        <p className="font-serif-el italic text-dore text-lg mt-2 relative">L'élégance qui vous ressemble</p>
      </div>

      <section className="max-w-6xl mx-auto px-6 py-16 grid md:grid-cols-2 gap-12 items-center">
        <Reveal>
          <div className="overflow-hidden hover-zoom aspect-[4/5] max-h-[560px]">
            <img src="https://customer-assets-39nsmqrw.emergentagent.net/job_mode-guadeloupe/artifacts/d8hp1p11_IMG_20260719_161226.webp" alt="Esther, fondatrice de La Boutique d'Esther" className="w-full h-full object-cover" />
          </div>
        </Reveal>
        <Reveal delay={0.1}>
          <div className="space-y-4 font-serif-el text-lg text-ardoise leading-relaxed">
            <p>Bienvenue ! Je suis Esther, passionnée de mode et fondatrice de La Boutique d'Esther, votre boutique mode féminine en Guadeloupe.</p>
            <p>J'ai créé cette boutique avec une idée simple : proposer aux femmes de Guadeloupe des vêtements et accessoires tendance, de qualité, à des prix accessibles.</p>
            <p>Chaque article est soigneusement sélectionné pour son style, sa qualité et son élégance. Je veux que chaque femme qui porte un article de La Boutique d'Esther se sente belle, confiante et unique.</p>
            <p>Merci de faire partie de cette aventure. Bienvenue dans votre boutique.</p>
          </div>
        </Reveal>
      </section>

      <section className="bg-white py-14 px-6">
        <div className="max-w-5xl mx-auto">
          <h2 className="font-display text-3xl text-center text-encre mb-10">Nos valeurs</h2>
          <div className="grid grid-cols-2 md:grid-cols-5 gap-6">
            {VALUES.map((v, i) => (
              <Reveal key={i} delay={i * 0.05}>
                <div className="text-center">
                  <div className="w-14 h-14 rounded-full border border-dore/40 flex items-center justify-center mx-auto mb-3"><v.icon size={22} className="text-dore" /></div>
                  <p className="font-display text-lg text-encre">{v.t}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-noir py-14 px-6">
        <div className="max-w-5xl mx-auto grid grid-cols-2 md:grid-cols-4 gap-8 text-center">
          {STATS.map((s, i) => (
            <div key={i}>
              <p className="font-display text-4xl md:text-5xl text-dore">{s.n}</p>
              <p className="text-white/60 text-sm mt-1">{s.l}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
